import React from "react";

import { useTranslation } from "react-i18next";

import Text from "../../../../../../../components/ui/input/text/Input";
import IconPicker from "../../../../../../../components/ui/icon-picker/IconPicker";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
  SettingsOptionHeading,
} from "../../../styles";
import { useAdvancedTabsSingleStore } from "../../../../../../../stores/use-advanced-tabs-single-store";
import { ADVANCED_TABS_SINGLE_PROP } from "./defaults";

const AdvancedTabsSingleSettings = () => {
  const { data, setData } = useAdvancedTabsSingleStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));

  const { t } = useTranslation();
  return (
    <>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("content")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel>{t("title")}</OptionLabel>
          <OptionContent>
            <Text
              placeholder="Add..."
              value={data[ADVANCED_TABS_SINGLE_PROP.TITLE]}
              onChange={(value) =>
                setData({ [ADVANCED_TABS_SINGLE_PROP.TITLE]: value })
              }
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer>
          <OptionLabel>{t("icon")}</OptionLabel>
          <OptionContent>
            <IconPicker
              defaultTab="Icons"
              tabs={["Icons"]}
              icon={data[ADVANCED_TABS_SINGLE_PROP.ICON]}
              onChange={({ value }) =>
                setData({ [ADVANCED_TABS_SINGLE_PROP.ICON]: value })
              }
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
};

export default AdvancedTabsSingleSettings;
